var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomepageDecor2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 254,
    viewBox: "0 0 397 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000322031 123.215C56.771 100.02 120.178 78.8525 185.375 58.1736C251.126 37.663 318.377 17.7416 391.922 0C335.203 23.2122 271.796 44.3708 206.546 65.0413C140.769 85.5351 73.5181 105.448 0.0260452 123.207L-0.000322031 123.215Z",
    fill: "#FAE632"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8217 135.957C116.36 110.633 186.508 87.3446 258.447 64.5448C330.938 41.9133 404.93 19.8709 485.242 0C421.756 25.3415 351.582 48.6295 279.617 71.4125C207.1 94.0271 133.107 116.061 52.8217 135.957Z",
    fill: "#FAE632"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.669 148.691C175.975 121.237 252.89 95.8282 331.57 70.9075C410.776 46.1635 491.509 22.0003 578.614 0C508.361 27.4709 431.42 52.8797 352.714 77.7836C273.455 102.519 192.696 126.674 105.669 148.691Z",
    fill: "#FAE632"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.412 161.417C235.459 131.842 319.115 104.312 404.535 77.2702C490.482 50.4053 577.983 24.1212 671.803 0C594.809 29.5918 511.126 57.1216 425.68 84.1464C339.68 110.994 252.206 137.279 158.412 161.417Z",
    fill: "#FAE632"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.444 174.201C381.205 111.525 566.528 53.1827 765.518 0C595.862 62.7184 410.328 120.976 211.444 174.201Z",
    fill: "#FAE632"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264.45 186.985C447.798 120.034 646.63 57.4498 859.206 0C675.963 66.9855 476.895 129.494 264.45 186.985Z",
    fill: "#FAE632"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.456 199.77C514.391 128.551 726.731 61.7253 952.868 0C756.064 71.2526 543.488 138.011 317.456 199.77Z",
    fill: "#FAE632"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M370.514 212.554C581.011 137.077 806.858 65.9924 1046.56 0C836.192 75.5197 610.107 146.528 370.514 212.554Z",
    fill: "#FAE632"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageDecor2);
export default __webpack_public_path__ + "static/media/homepage-decor-2.05492c0e974f164a65cc68bdeea6c93d.svg";
export { ForwardRef as ReactComponent };